import styled from "@emotion/styled";
import { bool, func, number, string } from "prop-types";
import React, { useEffect, useRef, useState } from "react";

import theme from "../../../theme";
import mq from "../../../utils/mediaQuery";
import Heading from "../../Heading";
import Icon from "../../Icon";

const Item = styled.div`
  border-bottom: 1px solid ${theme.color("dark.base")};
  &:first-of-type {
    border-top: 1px solid ${theme.color("dark.base")};
  }
  min-height: 86px;
  overflow: hidden;
`;

const ItemHeading = styled.div`
  display: flex;
  align-items: center;
  padding: 2rem 0;
`;

const StyledHeading = styled(Heading)`
  margin-right: auto;
`;

const HeadingCount = styled.span`
  margin-right: ${theme.spacing("xs")};
  color: ${theme.color("primary")};
`;

const ContentFloater = styled.div`
  position: relative;
  background-color: ${theme.color("background.base")};
  overflow: hidden;
  transition: ${theme.get("transition.default.transition")};
`;
const Content = styled.div`
  padding: 0 ${theme.spacing("xs")} ${theme.spacing("l")};
`;

const Image = styled.img`
  width: 100%;
  ${mq("2")} {
    width: 50%;
  }
`;

const AccordionItem = ({
  id,
  heading,
  body,
  image,
  selected,
  showNumber,
  setSelected,
}) => {
  const [itemHeight, setItemHeight] = useState(0);
  const contentRef = useRef();

  useEffect(() => {
    const contentElement = contentRef && contentRef.current;

    if (selected === id) {
      setItemHeight(contentElement.clientHeight);
    } else {
      setItemHeight(0);
    }
  }, [id, selected]);

  const toggleState = () => {
    setSelected(selected === id ? null : id);
  };

  return (
    <Item>
      <ItemHeading onClick={() => toggleState()}>
        <StyledHeading size={3}>
          {showNumber && (
            <HeadingCount>
              {(id + 1).toLocaleString(undefined, { minimumIntegerDigits: 2 })}
            </HeadingCount>
          )}
          {heading}
        </StyledHeading>
        <Icon
          type={selected === id ? "minus" : "plus"}
          width="22px"
          height="22px"
        />
      </ItemHeading>
      <ContentFloater style={{ height: `${itemHeight}px` }}>
        <Content ref={contentRef}>
          {image && <Image src={image} alt={heading} />}
          <div>{body}</div>
        </Content>
      </ContentFloater>
    </Item>
  );
};

export const AccordionItemType = {
  heading: string.isRequired,
  body: string.isRequired,
  image: string,
};

AccordionItem.propTypes = {
  ...AccordionItemType,
  id: number,
  selected: number,
  setSelected: func.isRequired,
  showNumber: bool,
};

export default AccordionItem;
